<template>
  <div v-if="activado">
    <div
      v-if="isdevmode"
      class="red white--text"
      style="width: 130px; z-index: 3; position: absolute; height: 18px; left: 0">
      <p class="ma-0 pa-0"><b>MODO PRUEBAS</b></p>
    </div>
    <nav class="navbar navbar-light bg-light navbar-global navbar-fixe-top">
      <div class="container-fluid" xstyle="overflow-x: auto">
        <div class="navbar-header" style="margin-left: 0px">
          <button
            type="button"
            class="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#navbar"
            aria-expanded="false"
            aria-controls="navbar">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand" :href="redirect">
            <div class="container-fluid" style="height: 33px !important">
              <img
                id="profile-im"
                class="profile-img-car img-responsive center-block"
                :src="$store.state.unidad.logo"
                style="width: 60px; height: 100%" />
            </div>
          </a>
        </div>

        <div id="navbar" class="collapse navbar-collapse text-right barrita" style="">
          <ul class="nav navbar-nav navbar-user navbar-right ul1">
            <li
              v-if="
                $store.state.CARGO &&
                ($store.state.CARGO.id == 1 ||
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25)
              ">
              <v-btn tile color="purple" small dark class="mr-4 mt-2 elevation-0" @click="openregistrarCaja()">
                <v-icon left>mdi-package-variant</v-icon> Caja
              </v-btn>
            </li>
            <li v-if="$store.state.CARGO" style="width: min-content; height: 45px" class="li1">
              <span class="form-group" style="display: inline-block; margin-bottom: 0">
                <span class="input-group input-group-sm" style="margin-top: 0px; overflow-x: scroll">
                  <v-select
                    :items="convenios"
                    v-model="$store.state.convenio"
                    item-text="nombre"
                    item-value="id"
                    class="mt-1"
                    style="min-width: 150px; max-width: 280px"
                    label="Convenio:"
                    outlined
                    dense
                    placeholder="Seleccione..."
                    hide-details
                    return-object
                    v-if="
                      $store.state.CARGO.sede.unidad_negocio == 1 || $store.state.CARGO.sede.unidad_negocio == 10
                    "></v-select>
                </span>
              </span>
            </li>
            <li style="width: min-content; height: 45px" class="li1">
              <span class="form-group" style="display: inline-block; margin-bottom: 0">
                <span class="input-group input-group-sm" style="margin-top: 0px; overflow-x: scroll">
                  <!-- <v-select
                    :items="$store.state.CARGOS"
                    v-model="$store.state.CARGO"
                    :disabled="!$store.state.show_rol_select"
                    item-text="nombre"
                    item-value="idsede"
                    class="mt-1 ml-1"
                    style="min-width: 150px; max-width: 250px"
                    label="Rol usuario:"
                    outlined
                    dense
                    placeholder="Seleccione..."
                    hide-details
                    return-object></v-select> --> 
                    <multiselect 
                      v-model="$store.state.CARGO" 
                      :options="$store.state.CARGOS"  
                      :disabled="!$store.state.show_rol_select"
                      track-by="idsede" 
                      label="nombre" 
                      class="form-control mt-1 ml-1" 
                      style="min-width: 220px; max-width: 250px; overflow-y: visible;"
                      :searchable="true" 
                      :close-on-select="true" 
                      :show-labels="false" 
                      :multiple="false" 
                      placeholder="Seleccione..." />
                </span>
              </span>
            </li>
            <li class="li1">
              <a href="#" @click="perfil">
                <span class="glyphicon glyphicon-user"></span>
                {{ $store.state.DATA_USER.nombres }}
              </a>
            </li>
            <!-- <li class="li1">
                <a href="#" @click="refresh()">
                  <span class="glyphicon glyphicon-user"></span>
                  refresh
                </a>
              </li> -->
            <li class="li1">
              <!-- <a @click="salir" class="btn btn-sm btn-link">
                  <span class="glyphicon glyphicon-log-out"></span> Salir
                </a> -->
              <v-menu open-on-hover top offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :loading="relogin_loading"
                    color="primary"
                    text
                    dark
                    v-bind="attrs"
                    hide-details
                    class="my-0 py-0"
                    v-on="on">
                    <span class="glyphicon glyphicon-log-out"></span>
                    Menu
                  </v-btn>
                </template>

                <v-card class="mx-auto" max-width="344" outlined>
                  <v-list-item three-line>
                    <v-list-item-content>
                      <div class="text-overline mb-4">Menu</div>
                      <v-list-item-title class="text-h5 mb-1">
                        {{ $store.state.DATA_USER.nombres }}
                      </v-list-item-title>
                      <v-list-item-subtitle>Sin comentarios :)</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-avatar tile size="80" color="grey"></v-list-item-avatar>
                  </v-list-item>

                  <v-card-actions>
                    <v-btn outlined color="red" square text @click="salir"> Salir </v-btn>
                    <v-btn outlined color="green" square text @click="relogin"> Re login </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </li>
          </ul>
        </div>
        <!--/.nav-collapse -->
      </div>
    </nav>

    <nav class="navbar-primary" id="navbar-primary-na">
      <div style="position: relative">
        <img
          :src="profile"
          alt="PERFIL"
          id="btn-expand-hi"
          class="text-center div-expand"
          style="width: 60px; margin: 8px auto; display: grid; border-radius: 50%" />
        <p class="text-center main-name" style="margin: 0; color: #1177d1; font-size: 13px; font-weight: bold">
          {{ $store.state.DATA_USER.nombres }}
          {{ $store.state.DATA_USER.pri_apellido }}
        </p>
        <div style="height: 25px; background: rgb(236, 238, 227)"></div>
      </div>

      <ul class="navbar-primary-menu">
        <li v-if="$store.state.CARGO?.id != 27">
          <router-link
            title="Feria"
            to=""
            data-toggle="collapse"
            data-target="#collapseFeria"
            style="background-color: #00763b">
            <span class="glyphicon glyphicon-cog"></span>
            <span class="nav-label white--text">
              Feria <span class="glyphicon glyphicon-chevron-down expand-right"></span>
            </span>
          </router-link>
          <div class="collapse" id="collapseFeria">
            <router-link title="Contactos feria" to="/contactosferia" style="background-color: #c0e7c3">
              <svg
                width="1.10em"
                height="1.18em"
                style="margin-right: 4px"
                viewBox="0 0 16 10"
                class="bi bi-file-earmark-person-fill"
                fill="#efefef"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  d="M2 2a2 2 0 0 1 2-2h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm7.5 1.5v-2l3 3h-2a1 1 0 0 1-1-1zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm2 5.755S12 12 8 12s-5 1.755-5 1.755V14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-.245z" />
              </svg>
              <span class="nav-label black--text"> Contactos </span>
            </router-link>
            <router-link
              title="Contactos feria"
              to="/insferia"
              style="background-color: #c0e7c3"
              v-if="
                $store.state.CARGO?.id == 1 || $store.state.DATA_USER.id == 14401 || $store.state.DATA_USER.id == 75939
              ">
              <svg
                width="1.10em"
                height="1.18em"
                style="margin-right: 4px"
                viewBox="0 0 16 10"
                class="bi bi-file-earmark-person-fill"
                fill="#efefef"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  d="M2 2a2 2 0 0 1 2-2h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm7.5 1.5v-2l3 3h-2a1 1 0 0 1-1-1zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm2 5.755S12 12 8 12s-5 1.755-5 1.755V14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-.245z" />
              </svg>
              <span class="nav-label black--text"> Inscripciones </span>
            </router-link>
          </div>
        </li>

        <li v-bind:key="menu.id" v-for="menu in $store.state.MENUS">
          <router-link v-if="menu.nombre == 'Contactos'" v-bind="{ to: menu.enlace }" :title="menu.nombre">
            <svg
              width="1.15em"
              height="1.15em"
              viewBox="0 0 16 16"
              class="bi bi-file-earmark-person-fill"
              fill="#1177D1"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                d="M2 2a2 2 0 0 1 2-2h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm7.5 1.5v-2l3 3h-2a1 1 0 0 1-1-1zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm2 5.755S12 12 8 12s-5 1.755-5 1.755V14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-.245z" />
            </svg>
            <span class="nav-label"> Mi Base de datos </span>
          </router-link>

          <div v-else-if="menu.nombre == 'Cargos'" style="position: relative">
            <router-link :title="menu.nombre" to="" data-toggle="collapse" data-target="#collapseSistema">
              <span class="glyphicon glyphicon-cog"></span>
              <span class="nav-label">
                Sistema <span class="glyphicon glyphicon-chevron-down expand-right"></span>
              </span>
            </router-link>

            <div class="collapse" id="collapseSistema">
              <router-link
                v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 2 || $store.state.CARGO.id == 3 || is_rol_administrador"
                :to="'/cargos'"
                title="''">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Cargos</span>
              </router-link>
              <router-link :to="'/sedes'" title="''">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe"> Sedes </span>
              </router-link>
              <router-link
                v-if="$store.state.CARGO.id != 13 && $store.state.CARGO.id != 12"
                :to="'/usuarios'"
                title="''">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe"> Usuarios </span>
              </router-link>
              <router-link v-if="$store.state.CARGO.id == 1 || $store.state.DATA_USER.id == 9029" :to="'/unidades'" title="Gestionar unidades">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Unidades</span>
              </router-link>
              <!-- <router-link v-if="$store.state.CARGO.id == 1" :to="'/xsucursales'" title="Gestionar Sucursales">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                  <span class="nav-labe">Sucursales</span>
                </router-link>
                <router-link v-if="$store.state.CARGO.id == 1" :to="'/nits'" title="Gestionar nits">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                  <span class="nav-labe">Nits</span>
                </router-link> -->
              <router-link
                v-if="
                  $store.state.CARGO.id == 1 ||
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25 || 
                  $store.state.DATA_USER.id == 9029
                "
                :to="'/datosfacturaele'"
                title="Configuracion Datos Factura E.">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe"> <small>Factura config.</small> </span>
              </router-link>
              <router-link v-if="$store.state.CARGO.id == 1 || is_rol_administrador" :to="'/nominaciones'" title="Gestionar nominaciones">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Nominaciones</span>
              </router-link>

              <router-link v-if="$store.state.CARGO.id == 1 || is_rol_administrador" :to="'/excelins'" title="Subir excel de estudiantes">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Est. Excel</span>
              </router-link>
            </div>
          </div>

          <div v-else-if="menu.nombre == 'Mis inscripciones'" style="position: relative">
            <router-link :title="menu.nombre" to="" data-toggle="collapse" data-target="#collapseMarketing">
              <span class="glyphicon glyphicon-bullhorn"></span>
              <span class="nav-label">
                Marketing <span class="glyphicon glyphicon-chevron-down expand-right"></span>
              </span>
            </router-link>

            <div class="collapse" id="collapseMarketing">
              <router-link :to="'/misinscripciones'" title="''">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Inscripciones</span>
              </router-link>
              <router-link :to="'/contactos'" title="''">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Base de datos</span>
              </router-link>
              <div
                @click="irAWebinars()"
                vv-if="$store.state.DATA_USER.id == 43"
                class="btnwebinar"
                style="border-bottom: 1px solid #999999">
                <span
                  class="glyphicon glyphicon-minus"
                  style="margin-left: 2.5em; padding-top: 0.8em; padding-bottom: 1.2em">
                </span>
                <span class="nav-labe"> Webinars </span>
              </div>
              <div
                @click="irAWapito()"
                vv-if="$store.state.DATA_USER.id == 43"
                class="btnwebinar"
                style="border-bottom: 1px solid #999999">
                <span
                  class="glyphicon glyphicon-minus"
                  style="margin-left: 2.5em; padding-top: 0.8em; padding-bottom: 1.2em">
                </span>
                <span class="nav-labe"> Wapito </span>
              </div>
            </div>
          </div>

          <div v-else-if="menu.nombre == 'Postgrados'" style="position: relative">
            <router-link :title="menu.nombre" to="" data-toggle="collapse" data-target="#collapseAcademico">
              <span class="glyphicon glyphicon-education"></span>
              <span class="nav-label">
                Academico <span class="glyphicon glyphicon-chevron-down expand-right"></span>
              </span>
            </router-link>

            <div class="collapse" id="collapseAcademico">
              <router-link v-if="veroferta" :to="'/oferta_academica'" title="Oferta academica">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Oferta Acad.</span>
              </router-link>

              <router-link
                :to="'/postgrados'"
                title="''"
                v-if="
                  ($store.state.DATA_USER.id == 3506 ||
                  ($store.state.CARGO.id != 11 &&
                    $store.state.CARGO.id != 12 &&
                    $store.state.CARGO.id != 13 &&
                    $store.state.CARGO.id != 14 &&
                    $store.state.CARGO.id != 24 &&
                    $store.state.CARGO.id != 15 &&
                    $store.state.CARGO.id != 25)) && $store.state.CARGO.sede.unidad_negocio != -10
                ">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe"> {{ $store.state.unidad.postgrados }} </span>
              </router-link>
              <!-- <router-link
                  :to="'/xprogramas'"
                  title="Programas Siglo XX"
                  v-if="
                    $store.state.CARGO.id == 1 ||
                      $store.state.CARGO.id == 170 ||
                      $store.state.CARGO.id == 60 ||
                      $store.state.CARGO.id == 70
                  "
                >
                  <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                  <span class="nav-labe"> Proyectos </span>
                </router-link> -->
              <router-link :to="'/programas'" title="''">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe"> {{ $store.state.unidad.programas }} </span>
              </router-link>
              <!-- <router-link :to="'/calificacionesv2'" title="''">
                                <span
                                  class="glyphicon glyphicon-minus"
                                  style="margin-left: 26px"
                                ></span>
                                <span class="nav-labe"> Calificaciones </span>
                              </router-link> -->
              <router-link v-if="permisosResponsablesAdmisiones || permisosResponsablesTitulaciones || permisosDNA" :to="{ name: 'documentos-inscripciones' }" title="Documentos Inscripciones">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe"> Doc. Inscrip. </span>
              </router-link>

              <router-link :to="'/personas'" title="''" v-if="$store.state.CARGO.id != 24">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe"> Personas </span>
              </router-link>
              <router-link
                v-if="
                  $store.state.CARGO.id == 6 ||
                  $store.state.CARGO.id == 5 ||
                  $store.state.CARGO.id == 17 ||
                  $store.state.CARGO.id == 1 || 
                  $store.state.DATA_USER.id == 9029
                "
                :to="'/menureportetitulaciones'"
                title="Reporte Titulaciones">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Reporte Titls.</span>
              </router-link>
              <router-link
                :to="'/migracionacademico'"
                title="Migracion Academico"
                v-if="$store.state.CARGO.id != 3 && $store.state.CARGO.id != 26 && $store.state.CARGO.id != 27">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Migracion Academico</span>
              </router-link>
              <router-link
                :to="'/solicitudesuniversidadcertificados'"
                title="Sol Certificados Universidad"
                v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 26 || $store.state.CARGO.id == 4">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Sol Certificados Universidad</span>
              </router-link>
              <router-link
                :to="'/programasuniversidadcertificados'"
                title="Certificaciones Universidad"
                v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 26 || $store.state.CARGO.id == 4">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Certificaciones Univ</span>
              </router-link>
              
              
              <!-- <router-link
                  v-if="
                    $store.state.CARGO.id == 6 ||
                    $store.state.CARGO.id == 5 ||
                    $store.state.CARGO.id == 17 ||
                    $store.state.CARGO.id == 1
                  "
                  :to="'/reportestitulaciones'"
                  title="'Reporte titulaciones'">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                  <span class="nav-labe"> Reporte Tit. </span>
                </router-link> -->
              <!-- <router-link :to="'/oferta_acadenika'" title="''" v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 22">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                  <span class="nav-labe"> Oferta A. </span>
                </router-link> -->
              <router-link
                v-if="$store.state.CARGO.id == 8 || $store.state.CARGO.id == 1 || $store.state.DATA_USER.id == 9029"
                :to="'/plataformas'"
                title="''">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe"> Plataformas </span>
              </router-link>


              <router-link
                :to="'/solicitud-modificaciones-calificaciones'"
                title="''">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe"> Sol. Modificacion Calificaciones </span>
              </router-link>

              <div
                vv-if="$store.state.CARGO.id == 1"
                vvv-if="isdevmode"
                @click="irPortal2()"
                class="btnwebinar"
                style="border-bottom: 1px solid #999999">
                <span
                  class="glyphicon glyphicon-minus"
                  style="margin-left: 2.5em; padding-top: 0.8em; padding-bottom: 1.2em; padding-right: 0.5em">
                </span>
                <span class="nav-labe"> Proyectos </span>
              </div>

              <!--  <router-link
                  v-if="
                    $store.state.CARGO.id == 14 ||
                    $store.state.CARGO.id == 15 ||
                    $store.state.CARGO.id == 5 ||
                    $store.state.CARGO.id == 6 ||
                    $store.state.CARGO.id == 7 ||
                    $store.state.CARGO.id == 1
                  "
                  :to="'/reportecuenta'"
                  title="Reporte cuenta">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                  <span class="nav-labe">Cuentas</span>
                </router-link> -->

              <!-- <router-link v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 17 || $store.state.CARGO.id == 6 || $store.state.CARGO.id == 7" :to="'/certificacionestram'" title="Certificaciones de tramites">
                                  <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                                  <span class="nav-labe">Certificaciones</span>
                              </router-link> -->
              <!-- <router-link v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 17 || $store.state.CARGO.id == 6 || $store.state.CARGO.id == 7" :to="'/proyectosmenu'" title="Habilitacion de proyectos">
                                  <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                                  <span class="nav-labe">Proyectos</span>
                              </router-link>  -->
            </div>
          </div>

          <!-- OCULTA EL MENU CONTABILIDAD PARA MARKETEROS -->
          <div
            v-else-if="menu.nombre == 'Facturas' && ($store.state.CARGO.id == 13 || $store.state.CARGO.id == 12)"
            style="position: relative"></div>

          <div v-else-if="menu.nombre == 'Facturas'" style="position: relative">
            <router-link
              v-if="!$store.state.isonlyread || is_rol_administrador"
              :title="menu.nombre"
              to=""
              data-toggle="collapse"
              data-target="#collapseContabilidad">
              <span class="glyphicon glyphicon-credit-card"></span>
              <span class="nav-label">
                Contabilidad <span class="glyphicon glyphicon-chevron-down expand-right"></span>
              </span>
            </router-link>

            <div class="collapse" id="collapseContabilidad" v-if="$store.state.CARGO.id != 13">
              <router-link
                :to="'/recibos'"
                title="Comprobantes de pago"
                v-if="$store.state.CARGO.sede.id != 19 && $store.state.CARGO.id != 3">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Pagos</span>
              </router-link>
              <router-link
                :to="'/cajas'"
                title="Caja"
                v-if="
                  $store.state.CARGO.id == 1 ||
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25 || is_rol_administrador
                ">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe"> Mis Cajas </span>
              </router-link>
              <router-link
                :to="'/depositosede'"
                title="depositosede"
                v-if="
                  $store.state.CARGO.id == 1 ||
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25 || is_rol_administrador
                ">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe"> Depositos Caja </span>
              </router-link>
              <router-link
                :to="'/facturascv'"
                title="Facturas de compra y venta"
                v-if="
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25 ||
                  $store.state.CARGO.id == 27 ||
                  $store.state.CARGO.id == 1 || is_rol_administrador
                ">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Facturas C-V</span>
              </router-link>
              <router-link
                :to="'/facturased'"
                title="Facturas de Sector Educativo"
                v-if="
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25 ||
                  $store.state.CARGO.id == 27 ||
                  $store.state.CARGO.id == 1 || is_rol_administrador
                ">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Facturas S-E</span>
              </router-link>
              <router-link :to="'/notasdc'" title="Notas debito credito" v-if="$store.state.CARGO.id == 310 || is_rol_administrador">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Notas D-C</span>
              </router-link>
              <!-- <router-link
                  v-if="($store.state.CARGO.id == 21 && $store.state.CARGO.sede.id == 19) || $store.state.CARGO.id == 1"
                  :to="'/recibosbenito'"
                  title="'Recibos Para Univ. Benito Juarez'"
                >
                  <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                  <span class="nav-labe">Recibos Juarez</span>
                </router-link> -->
              <router-link
                :to="'/consolidarfact'"
                title="Consolidar facturas"
                v-if="$store.state.CARGO.id != 3 && $store.state.CARGO.id != 26 && $store.state.CARGO.id != 27 || is_rol_administrador">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Consolidar F.</span>
              </router-link>
              <router-link
                :to="'/facturaslista'"
                title="Facturas por sede"
                v-if="$store.state.CARGO.id != 3 && $store.state.CARGO.id != 26 && $store.state.CARGO.id != 27 || is_rol_administrador">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Facturas</span>
              </router-link>
              <router-link
                v-if="
                  $store.state.DATA_USER.id == 31 ||
                  $store.state.DATA_USER.id == 6457 ||
                  $store.state.CARGO.id == 18 ||
                  $store.state.CARGO.id == 1 || is_rol_administrador
                "
                :to="'/facturaslistaext'"
                title="'Facturas externo'">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Facturas Nal.</span>
              </router-link>
              <router-link
                v-if="
                  $store.state.CARGO.id == 19 ||
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25 ||
                  $store.state.CARGO.id == 1 || is_rol_administrador
                "
                :to="'/descuentoslista'"
                title="'Reporte mensual editable'">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe"> Descuentos </span>
              </router-link>
              <router-link
                v-if="$store.state.CARGO.id == 19 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 1 || is_rol_administrador"
                :to="'/motivos-descuento'"
                title="Motivos de descuentos">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Motivos Des.</span>
              </router-link>
              <router-link
                v-if="
                  $store.state.CARGO.id == 19 ||
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25 ||
                  $store.state.CARGO.id == 1 ||
                  $store.state.CARGO.id == 3 ||
                  $store.state.CARGO.id == 17 ||
                  $store.state.CARGO.id == 26 ||
                  $store.state.CARGO.id == 22 || is_rol_administrador
                "
                :to="'/asignacionesmenu'"
                title="Asignaciones">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Asignaciones</span>
              </router-link>
              <router-link
                v-if="
                  $store.state.CARGO.id == 19 ||
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25 ||
                  $store.state.CARGO.id == 1 || is_rol_administrador
                "
                :to="'/contratoslista'"
                title="Ver contratos generados">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Ver Contratos</span>
              </router-link>
              <!-- <router-link v-if="$store.state.CARGO.id == 19 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 1" :to="'/asignacionesv2s'" title="Asignaciones por sede">
                                  <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                                  <span class="nav-labe">Asig. sedes</span>
                              </router-link> -->
              <router-link
                :to="'/promociones'"
                title="'Promociones'"
                v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || is_rol_administrador">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe"> Promociones </span>
              </router-link>

              <router-link
                :to="'/pagos_templates'"
                title="'Pagos por defecto'"
                v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || is_rol_administrador">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe"> Prog. pagos </span>
              </router-link>

              <router-link
                :to="'/AntiguosRecibos'"
                title="'Antiguos recibos'"
                v-if="
                  (!$store.state.isonlyread &&
                  $store.state.CARGO.id != 3 &&
                  $store.state.CARGO.id != 26 &&
                  $store.state.CARGO.id != 27) || is_rol_administrador
                ">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe"> Rec. Antiguos </span>
              </router-link>

              <!-- <router-link
                  :to="'/nominaciones'"
                  title="Nominaciones"
                  v-if="!$store.state.isonlyread && $store.state.CARGO.id != 3">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                  <span class="nav-labe"> Nominaciones </span>
                </router-link> -->
            </div>
          </div>

          <div v-else-if="menu.nombre == 'Planificador'" style="position: relative">
            <div v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 22 || $store.state.CARGO.id == 26 || is_rol_administrador">
              <router-link :title="menu.nombre" to="" data-toggle="collapse" data-target="#collapsePlanificador">
                <span class="glyphicon glyphicon-signal"></span>
                <span class="nav-label">
                  Planificador <span class="glyphicon glyphicon-chevron-down expand-right"></span>
                </span>
              </router-link>

              <div class="collapse" id="collapsePlanificador">
                <router-link :to="'/oferta_acadenika'" title="''">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                  <span class="nav-labe"> Oferta A. </span>
                </router-link>
                <router-link :to="'/xreporteporsede'" title="'Reporte todos por sede'">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                  <span class="nav-labe"> Reporte MKT2. </span>
                </router-link>
                <router-link
                  v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 22 || is_rol_administrador"
                  :to="'/menureportetitulaciones'"
                  title="Reporte Titulaciones">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                  <span class="nav-labe">Reporte Titulaciones</span>
                </router-link>
              </div>
            </div>
          </div>

          <div v-else-if="menu.nombre == 'Presupuesto'" style="position: relative">
            <router-link
              v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador"
              :title="menu.nombre"
              to=""
              data-toggle="collapse"
              data-target="#collapsePresupuesto">
              <span class="glyphicon glyphicon-cog"></span>
              <span class="nav-label">
                Presupuesto <span class="glyphicon glyphicon-chevron-down expand-right"></span>
              </span>
            </router-link>

            <div class="collapse" id="collapsePresupuesto">
              <router-link
                v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador"
                title="Opciones de Presupuestos"
                to=""
                data-toggle="collapse"
                data-target="#collapseOpcionesPresupuestos">
                <span style="color: #4a4a4a" class="nav-label">
                  Opciones de Presupuestos
                  <span style="font-size: 10px" class="glyphicon glyphicon-plus"></span>
                </span>
              </router-link>

              <div class="collapse" id="collapseOpcionesPresupuestos">
                <router-link
                  :to="'/presupuestos'"
                  title="'Presupuestos (Gastos / Ingresos)'"
                  v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                  <span class="nav-labe"> Presupuestos (Gastos / Ingresos)</span>
                </router-link>

                <router-link
                  :to="'/presupuestos-consolidados'"
                  title="'Presupuestos Consolidados (Gastos / Ingresos)'"
                  v-if="permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                  <span class="nav-labe"> Presupuestos Consolidados (Gastos / Ingresos)</span>
                </router-link>

                <router-link
                  :to="'/presupuestos-ingresos-estimaciones'"
                  title="'Presupuesto de Ingresos Estimados'"
                  v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                  <span class="nav-labe"> Presupuesto de Ingresos Estimados</span>
                </router-link>

                <router-link
                  :to="'/presupuestos-ingresos-proyectados'"
                  title="'Ingresos Proyectados Gestion Anterior'"
                  v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                  <span class="nav-labe">Ingresos Proyectados Gestion Anterior</span>
                </router-link>

                <router-link
                  :to="'/presupuestos-ingresos-reportes'"
                  title="'Presupuesto de Ingresos Reportes'"
                  v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                  <span class="nav-labe">Presupuesto de Ingresos Reportes</span>
                </router-link>
              </div>
            </div>
          </div>

          <div v-else-if="menu.nombre == 'Tesorería'" style="position: relative">
            <router-link
              v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador"
              :title="menu.nombre"
              to=""
              data-toggle="collapse"
              data-target="#collapseTesoreria">
              <span class="glyphicon glyphicon-inbox"></span>
              <span class="nav-label">
                Tesorería <span class="glyphicon glyphicon-chevron-down expand-right"></span>
              </span>
            </router-link>

            <div class="collapse" id="collapseTesoreria">
              <router-link
                v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador"
                title="Solicitud Recursos"
                to=""
                data-toggle="collapse"
                data-target="#collapseOpcionesSolicitudRecursos">
                <span style="color: #4a4a4a" class="nav-label">
                  Solicitud Recursos
                  <span style="font-size: 10px" class="glyphicon glyphicon-plus"></span>
                </span>
              </router-link>

              <div class="collapse" id="collapseOpcionesSolicitudRecursos">
                <router-link
                  v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador"
                  :to="'/presupuestos-solicitud-transferencia-recursos'"
                  title="'Presupuestos Solicitud Transferencia de recursos'">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                  <span class="nav-labe"> Solicitud de Trans. Recursos</span>
                </router-link>

                <router-link
                  v-if="permisosPresupuestos2 || is_rol_administrador"
                  :to="'/presupuestos-transferencia-entre-sedes'"
                  title="Solicitud de Trans. Entre Sedes y Otros">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                  <span class="nav-labe">Solicitud de Trans. Entre Sedes y Otros</span>
                </router-link>

                <router-link
                  v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador"
                  :to="'/presupuestos-transferencia-entre-sedes-desembolsadas'"
                  title="'Solicitud de Trans. Entre Sedes y Otros Desembolsadas'">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                  <span class="nav-labe"> Solicitud de Trans. Entre Sedes y Otros Desembolsadas</span>
                </router-link>

                <router-link
                  v-if="permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador"
                  :to="'/presupuestos-ejecucion-de-recursos'"
                  title="Ejecución de Recursos">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                  <span class="nav-labe">Ejecución de Recursos</span>
                </router-link>

                <router-link
                  v-if="permisosPresupuestos2 || permisosPresupuestos3 || is_rol_administrador"
                  :to="'/presupuestos-reporte-desembolsos-por-item'"
                  title="Reporte de Desembolsos por Ítem">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                  <span class="nav-labe">Reporte de Desembolsos</span>
                </router-link>
              </div>

              <router-link
                v-if="permisosPresupuestos2 || is_rol_administrador"
                title="Configuraciones"
                to=""
                data-toggle="collapse"
                data-target="#collapseConfiguraciones">
                <span style="color: #4a4a4a" class="nav-label">
                  Configuraciones
                  <span style="font-size: 10px" class="glyphicon glyphicon-plus"></span>
                </span>
              </router-link>

              <div class="collapse" id="collapseConfiguraciones">
                <router-link
                  :to="'/presupuestos-configuraciones-generales'"
                  title="'Generales'"
                  v-if="permisosPresupuestos2 || is_rol_administrador">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                  <span class="nav-labe">Generales</span>
                </router-link>

                <router-link :to="'/presupuestos-gestiones'" title="'Gestiones'" v-if="permisosPresupuestos2 || is_rol_administrador">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                  <span class="nav-labe">Gestiones</span>
                </router-link>

                <router-link to="/presupuestos-clasificadores" title="Clasificadores" v-if="permisosPresupuestos2 || is_rol_administrador">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                  <span class="nav-labe"> Clasificadores </span>
                </router-link>

                <router-link to="/presupuestos-grupos" title="Grupos" v-if="permisosPresupuestos2 || is_rol_administrador">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                  <span class="nav-labe"> Grupos </span>
                </router-link>

                <router-link
                  v-if="permisosPresupuestos2 || is_rol_administrador"
                  :to="'/presupuestos-cuentas-pagadoras'"
                  title="'Presupuestos Cuentas Pagadoras'">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                  <span class="nav-labe">Ctas. Pagadoras</span>
                </router-link>

                <router-link
                  :to="'/presupuestos-unidades-medida'"
                  title="'Presupuestos Unidades de Medida'"
                  v-if="permisosPresupuestos2 || is_rol_administrador">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                  <span class="nav-labe">Uds. Medida</span>
                </router-link>

                <router-link :to="'/presupuestos-sedes'" title="'Presupuestos Sedes'" v-if="permisosPresupuestos2 || is_rol_administrador">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                  <span class="nav-labe">Sedes</span>
                </router-link>
              </div>
            </div>
          </div>

          <!-- <div v-else-if="menu.nombre == 'Gastos'" style="position: relative">
            <router-link
              v-if="permisosPresupuestos1 || permisosPresupuestos2 || permisosGerentes || permisosGestionEmpresarial"
              :title="menu.nombre"
              to=""
              data-toggle="collapse"
              data-target="#collapseGastos">
              <span class="glyphicon glyphicon-list"></span>
              <span class="nav-label">
                Gastos
                <span class="glyphicon glyphicon-chevron-down expand-right"></span>
              </span>
            </router-link>

            <div class="collapse" id="collapseGastos">
              <router-link
                v-if="permisosPresupuestos1 || permisosGerentes || permisosGestionEmpresarial"
                :to="{ name: 'gastos.programas' }"
                title="Programa">
                <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                <span class="nav-labe">Programas</span>
              </router-link>

              <router-link
                v-if="permisosPresupuestos2 || permisosGerentes || permisosGestionEmpresarial"
                :to="{ name: 'gastos.desembolsos' }"
                title="Desembolsos">
                <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                <span class="nav-labe">Desembolsos</span>
              </router-link>

              <router-link
                v-if="permisosPresupuestos2 || permisosGerentes || permisosGestionEmpresarial"
                :to="{ name: 'gastos.gastos' }"
                title="Gastos">
                <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                <span class="nav-labe">Gastos</span>
              </router-link>

              <router-link
                v-if="permisosPresupuestos2 || permisosGestionEmpresarial"
                :to="{ name: 'gastos.tipos' }"
                title="Tipos de Gastos">
                <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                <span class="nav-labe">Tipos de Gastos</span>
              </router-link>
            </div>
          </div> -->

          <div v-else-if="menu.nombre == 'Pago'" style="position: relative">
            <router-link
              v-if="
                permisosAcademicosSede ||
                permisosAcademicosNacional ||
                permisosGestionEmpresarial ||
                permisosContabilidadNacional ||
                permisosPresupuestos1 ||
                permisosPresupuestos2 || is_rol_administrador ||
                permisosAcademicosSedeSoloLectura
              "
              :title="menu.nombre"
              to=""
              data-toggle="collapse"
              data-target="#collapsePago">
              <span class="glyphicon glyphicon-tag"></span>
              <span class="nav-label"> Pago <span class="glyphicon glyphicon-chevron-down expand-right"></span> </span>
            </router-link>

            <div class="collapse" id="collapsePago">
              <router-link
                v-if="permisosAcademicosSede || permisosAcademicosNacional || is_rol_administrador || permisosAcademicosSedeSoloLectura"
                to="/pagos-programas"
                title="Programas">
                <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                <span class="nav-labe">Programas</span>
              </router-link>

              <router-link v-if="permisosAcademicosNacional || is_rol_administrador" to="/pagos-sede-universidad" title="Sedes Universidades">
                <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                <span class="nav-labe">Sedes Universidades</span>
              </router-link>

              <router-link
                v-if="permisosAcademicosSede || permisosPresupuestos1 || is_rol_administrador || permisosAcademicosSedeSoloLectura"
                to="/pagos-programa-universidad-sede"
                title="Programas Universidades (Sedes)">
                <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                <span class="nav-labe">Programas Universidades (Sedes)</span>
              </router-link>

              <!-- TODO:  analizar si permisosContabilidadNacional esta correcto -->
              <router-link
                v-if="permisosAcademicosNacional || permisosGestionEmpresarial || permisosContabilidadNacional || is_rol_administrador"
                to="/pagos-programa-universidad-nacional"
                title="Programas Universidades (Nacional)">
                <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                <span class="nav-labe">Programas Universidades (Nacional)</span>
              </router-link>

              <router-link
                v-if="permisosAcademicosNacional || permisosGestionEmpresarial || is_rol_administrador"
                to="/pagos-solicitudes-inscripciones"
                title="Solicitudes Inscripciones">
                <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                <span class="nav-labe">Solicitudes Inscripciones</span>
              </router-link>

              <router-link
                v-if="permisosPresupuestos2 || permisosAcademicosNacional || permisosGestionEmpresarial || permisosContabilidadNacional || is_rol_administrador"
                to="/pagos-solicitudes"
                title="Solicitudes Pagos">
                <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                <span class="nav-labe">Solicitudes Pagos</span>
              </router-link>

              <router-link
                v-if="
                  permisosAcademicosNacional ||
                  permisosPresupuestos2 ||
                  permisosGestionEmpresarial ||
                  permisosContabilidadNacional || is_rol_administrador
                "
                to="/pagos-solicitudes-agrupados"
                title="Solicitudes Pagos Agrupados">
                <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                <span class="nav-labe">Solicitudes Pagos Agrupados</span>
              </router-link>

              <router-link
                v-if="permisosAcademicosNacional || permisosGestionEmpresarial"
                to="/pagos-inscripciones-programas-universidad"
                title="Inscripciones Progrogramas Universidades">
                <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                <span class="nav-labe">Inscripciones Progr. Univ.</span>
              </router-link>

              <router-link
                v-if="permisosAcademicosNacional || permisosPresupuestos2 || permisosContabilidadNacional || is_rol_administrador"
                title="Configuraciones"
                to=""
                data-toggle="collapse"
                data-target="#collapseConfiguracionesPago">
                <span style="color: #4a4a4a" class="nav-label">
                  Configuraciones
                  <span style="font-size: 10px" class="glyphicon glyphicon-plus"></span>
                </span>
              </router-link>

              <div class="collapse" id="collapseConfiguracionesPago">
                <router-link
                  v-if="permisosAcademicosNacional || permisosPresupuestos2 || permisosContabilidadNacional || is_rol_administrador"
                  to="/pagos-conceptos"
                  title="Conceptos">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                  <span class="nav-labe">Conceptos</span>
                </router-link>

                <router-link
                  v-if="permisosAcademicosNacional || permisosPresupuestos2 || permisosContabilidadNacional || is_rol_administrador"
                  to="/pagos-instituciones"
                  title="Instituciones">
                  <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                  <span class="nav-labe">Instituciones</span>
                </router-link>
              </div>
            </div>
          </div>

          <div v-else-if="menu.nombre == 'Comision'" style="position: relative">
            <router-link
              v-if="permisosPresupuestos2 || permisosInternacionalizacion || is_rol_administrador || permisosDNA"
              :title="menu.nombre"
              to=""
              data-toggle="collapse"
              data-target="#collapseComision">
              <span class="glyphicon glyphicon-usd"></span>
              <span class="nav-label">
                Comision <span class="glyphicon glyphicon-chevron-down expand-right"></span>
              </span>
            </router-link>

            <div class="collapse" id="collapseComision">
              <router-link v-if="(!permisosInternacionalizacion && !permisosDNA) || permisosPresupuestos2" to="/comisiones-sedes" title="Sedes">
                <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                <span class="nav-labe">Sedes</span>
              </router-link>

              <router-link v-if="!permisosInternacionalizacion" to="/comisiones-instituciones" title="Instituciones">
                <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                <span class="nav-labe">Instituciones</span>
              </router-link>

              <router-link v-if="!permisosInternacionalizacion" to="/comisiones-tipos-documentos-persona" title="Tipos Documentos Persona">
                <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                <span class="nav-labe">Tipos Documentos Persona</span>
              </router-link>

              <router-link v-if="!permisosDNA || permisosPresupuestos2" to="/comisiones-inscripciones-productividad" title="Inscripciones Productividad">
                <span class="glyphicon glyphicon-minus" style="margin-left: 5px"></span>
                <span class="nav-labe">Inscripciones Productividad</span>
              </router-link>
            </div>
          </div>

          <router-link v-else-if="menu.nombre != 'Dashboard'" v-bind="{ to: menu.enlace }" :title="menu.nombre">
            <span :class="menu.icono"></span>
            <span class="nav-label">{{ menu.nombre == 'Postgrados' ? menu_name : menu.nombre }}</span>
          </router-link>

          <div v-else-if="menu.nombre == 'Dashboard'" style="position: relative">
            <router-link :title="menu.nombre" to="" data-toggle="collapse" data-target="#collapseExampled">
              <span class="glyphicon glyphicon-stats"></span>
              <span class="nav-label">
                Dashboard <span class="glyphicon glyphicon-chevron-down expand-right"></span>
              </span>
            </router-link>

            <div class="collapse" id="collapseExampled">
              <router-link :to="'/efectivos'" title="'Efectivos'" v-if="$store.state.CARGO.id != 26">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Efectivos</span>
              </router-link>
              <router-link :to="'/xreporte'" title="'Reporte mensual editable'" v-if="$store.state.CARGO.id != 26">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe"> Reporte Marketing </span>
              </router-link>
              <router-link :to="'/xreporteporsede'" title="'Reporte todos por sede'">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe"> Reporte Mkt2 </span>
              </router-link>
              <router-link :to="'/xreportec'" title="'Reporte mensual editable'" v-if="$store.state.CARGO.id != 26">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe"> Reporte Semanas</span>
              </router-link>
              <router-link :to="'/semaforo'" title="'Semaforo'" v-if="$store.state.CARGO.id != 26">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Semaforo</span>
              </router-link>
              <router-link :to="'/semaforopro'" title="Programas" v-if="$store.state.CARGO.id != 26">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Programas</span>
              </router-link>
              <router-link :to="'/semaforoins'" title="'Semaforo'" v-if="$store.state.CARGO.id != 26">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Ins. por sede</span>
              </router-link>
              <router-link :to="'/semaforosed'" title="'Semaforo'" v-if="$store.state.CARGO.id != 26">
                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                <span class="nav-labe">Ins. por programa</span>
              </router-link>
              <!-- <router-link :to="'/semaforosline'" title="'Semaforo'">
                  <span class="glyphicon glyphicon-minus" style="margin-left:26px;"></span>
                  <span class="nav-label"> Evolucion </span>
                </router-link> -->
            </div>
          </div>
        </li>
        <p v-if="$store.state.MENUS.length == 0" class="text-center text-primary">{{ text_empty }}</p>

        <li v-if="$store.state.DATA_USER.id == 1">
          <a :href="`http://localhost:8081/#/?token=${token}`">
            <span class="glyphicon glyphicon-education"></span>
            <span class="nav-label"> Academico </span>
          </a>
        </li>
      </ul>
    </nav>

    <div class="main-content" id="main-contentid" :onresize="resize()">
      <div id="app">
        <router-view />
      </div>
    </div>

    <AModalPreinscritos ref="amodalpreinscritos" />
    <!-- <AModalConvenio ref="amodalconvenio" /> -->

    <v-dialog width="500">
      <v-card>
        <v-card-title class="text-h5 red darken-2 white--text"> Estas en el modo pruebas </v-card-title>

        <v-card-text>
          AVISO: en este modo de pruebas todos los datos ingresados no tienen ninguna validez.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false"> I accept </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <registrar ref="refagregar" v-on:success="()=>{}"/> -->
    <comprobar ref="refcomprobar" v-on:success="() => {}" />
  </div>
</template>
  
  <style lang="css">
@import '../components/estio_principal.css';
</style>
  
  <script lang="js">
    import gql from 'graphql-tag'
    import { mapMutations } from "vuex"; 
    import xaxios from '@/xaxios';
    import { getAccessToken,reloginManual } from "@/accessToken";
    import AModalPreinscritos from '@/components/AModalPreinscritos.vue';
    import {getUserData} from '@/accessToken.js';
    import {encryptToSendWebinars,encryptToSendWapito} from '@/accessToken.js';
    // import AModalConvenio from '@/components/AModalConvenioSelect.vue';
    // import registrar from './nominaciones/cajas/registrar.vue';
    import comprobar from './nominaciones/cajas/comprobar.vue';
    import { mapGetters } from 'vuex'; 
  
    export default {
      data(){
        return{
          app_name: process.env.VUE_APP_NAME,
          img_logo: process.env.VUE_APP_LOGO,
          url_client_email: process.env.VUE_APP_URL_CLIENT_EMAIL,
          location_user_pick: process.env.VUE_APP_URL_USERPICK,
          profile: "img/user-default.png",
          activado: true,
          text_empty: 'Cargando...',
          menus: [],
          convenios:[],
          usuario : {},
          me: '',
          redirect: '/'+process.env.VUE_APP_BASE_URL,
          menu_name: process.env.VUE_APP_NAME_MENU,
          isdevmode: false,
          veroferta: false,
          token: '',
          relogin_loading: false,
          is_rol_administrador: false
        }
      },
      components:{AModalPreinscritos,comprobar}, 
      apollo: {
        me: {
          query: gql `query{ me{ datos_personales{id,sexo,num_doc,nombres,pri_apellido,seg_apellido,estado,tipo,usuario{foto,firma,correo_corp}}, cargos{ idsede, cargo{id,nombre},sede{id,nombre,unidad_negocio,subsidiaria,subsidiaria_id,ubicacion,ubicacion_id},desde,hasta } } }`,
          result ({ data }) { 
            window.console.log('---------->',data?.me?.datos_personales);
            this.parseMe( data );
            this.token=getAccessToken();  // aqui
          },
        },
      },
      watch:{
        '$store.state.CARGO':function(a){
          if(a !=null ) {
            this.setCargoSedeStore(a);
            window.sessionStorage.setItem( 'XCARGO',JSON.stringify(a) );
            // window.console.log('CARGOOOO',a);
            this.getCategorias();
          }
          this.cargardata();
          // window.console.log( "CAMBIO CARGOOO ",a );
          this.parseMenus();
          this.$store.state.isonlyread = this.$store.state.CARGO.id == 22;
          //this.verificarPermisos();
        },
        'process.env.VUE_APP_GRAPHQL': function(){
          let apidev = process.env.VUE_APP_GRAPHQL;
          if( apidev.includes("apidev") ){ this.isdevmode = true; }
          else{ this.isdevmode = false; }
        },
        /*'$store.state.convenio': function(){
          this.abrirelmodalcito();
        }*/
  
      },
      computed: {
        ...mapGetters({
          permisosPresupuestos1: 'presupuesto/permisosPresupuestos1',
          permisosPresupuestos2: 'presupuesto/permisosPresupuestos2',
          permisosPresupuestos3: 'presupuesto/permisosPresupuestos3',
          permisosAcademicosSede: 'pago/permisosAcademicosSede',
          permisosAcademicosNacional: 'pago/permisosAcademicosNacional',
          permisosGestionEmpresarial: 'pago/permisosGestionEmpresarial',
          permisosContabilidadNacional: 'pago/permisosContabilidadNacional',
          permisosAcademicosSedeSoloLectura: 'pago/permisosAcademicosSedeSoloLectura',
          permisosInternacionalizacion: 'comision/permisosInternacionalizacion',
          permisosGerentes: 'gasto/permisosGerentes',
          permisosDNA: 'comision/permisosDNA',
          permisosResponsablesAdmisiones: 'comision/permisosResponsablesAdmisiones',
          permisosResponsablesTitulaciones: 'comision/permisosResponsablesTitulaciones',
        }),
      },
      methods:{
        ...mapMutations(['setCargoSedeStore', 'setCargosWithSedeStore']),
        salir(){
          window.localStorage.clear();
          window.sessionStorage.clear();
          this.$store.state.isLogin = false;
          //window.location.reload();
          this.activado = false;
          // window.location.href = "/portal"
          window.location.href = this.redirect
        },
        async relogin (){
          this.relogin_loading = true;
          let res = await reloginManual(); 
          if(res){
            this.$root.$notify.show("exito", {color:'green',x: 'right',});
          }else{
            this.$root.$notify.show("error actualice la pagina.", {color:'red',x: 'right',});
          }
          this.relogin_loading = false;
        },
        perfil(){
          window.sessionStorage.setItem( 'xperfil',JSON.stringify( this.$store.state.DATA_USER ) );
          this.$router.push({name:'perfil'});
        },
        /* abrirelmodalcito(){
          if(this.$store.state.CARGO && this.$store.state.CARGO.sede.unidad_negocio == 1 || $store.state.CARGO.sede.unidad_negocio == 10){
            if(!this.$store.state.convenio) this.$refs.amodalconvenio.openmodal();
          }
        }, */
        recibosesam( menu ){
          let enlace = menu.enlace;
          if( this.$store.state.CARGO ){
            if( this.$store.state.CARGO.sede.nombre.includes('Esam') ){
              enlace = 'recibosesam'
            }
          }
          return enlace;
        },
        openregistrarCaja(item=null){
          this.$refs.refcomprobar.openmodal(item);
        },
        parseMe( data ){
          //window.console.log('>>>>>>DATA: ',data);
          if(data?.me == null ){
            //SESION EXPIRADA, EL TOKEN YA NO ES VALIDO Y DEBE GENERARSE UNO NUEVO
            this.salir();
          }else{
            //this.abrirelmodalcito();
            // let names = data?.me?.datos_personales?.nombres+" "+data?.me?.datos_personales?.pri_apellido;
            // :) mucho molesta los pre inscritos, ademas solo sale en test
            // this.getpreinscritos(data.me?.datos_personales.id,names);
            // window.console.log('>>>>>>parseMe: ',data);
            this.$store.state.me = data?.me;
            //window.console.log(JSON.stringify(data),null,4)
            var me = data?.me;
            this.$store.state.DATA_USER = me?.datos_personales;
            if( me?.datos_personales.sexo == "F" ) this.profile= "img/user-default2.png";
  
            const ex = getUserData(); 
            this.text_empty = "Cargando...";
            if(ex){
              const parseado = JSON.parse(ex);
              const userdata = this.$store.state.DATA_USER;
              if( (parseado.clave+'').startsWith(userdata.num_doc) ){
                this.text_empty = "";
                
                this.$store.state.CARGO = {sede:{},cargo:{}}; 
                this.$router.push("/perfilchange");

                setTimeout(() => {
                  const n = document.getElementById('navbar-primary-na');
                  if(n){
                    const isColl = n.classList.contains('collapsed');
                    if(!isColl) n.classList.add('collapsed');
                    else n.classList.remove('collapsed');
                  }
                }, 300);
  
              }else{
                this.getdatadata(me);
              }
            }else{
              this.getdatadata(me);
            }
  
            
          }
        },
        getdatadata(me){
          try {
              var user = me?.datos_personales?.usuario;
              if( user ){
                var foto = user.foto;
                if( foto && foto.includes('.') ) this.profile= this.location_user_pick+foto;
              }
            } catch (error) {
              window.console.error( error );
            }
            this.$store.state.CARGO = me.cargos[0];           
            this.parseCargos();
            this.getGestiones();
            this.getCategorias();
            this.getSedes();
            this.eventomobile();
            this.getConveniosUniversidades();
        },
  
        getpreinscritos(idasesor,names){
          const vue = this;
          let url = `${process.env.VUE_APP_API_REST}/api/v1/asesores/publico/preinscritos/${idasesor}`;
          //let url = `http://localhost:8090/api/v1/asesores/publico/preinscritos/${idasesor}`;
          var config = {
            method: 'get',
            url: url,
          };
  
          xaxios.request(config)
          .then(function (response) {
            //if( !response.data ) response.data = {data:[]};
            let datos = response.data.data;
            //window.console.log('getpreinscritos>>>>',datos);
            if(vue.$refs.amodalpreinscritos) vue.$refs.amodalpreinscritos.openmodal(datos,names)
          })
          .catch(function (error) {
            window.console.log('>>>',error);
          });
        },
        parseMenus(){
          // window.console.log('this.$store.state.CARGO',this.$store.state.CARGO);
          var vue = this;
          this.$store.state.MENUS=[];
          if( this.$store.state.CARGO == null ){ window.console.error( "CARGO NULO" ); return; }
          let cid = this.$store.state.CARGO.id;
          this.is_rol_administrador = cid == 4 || cid == 22;
          let sedeid = this.$store.state.CARGO.sede.id;
          // let unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
          if(cid==27){
            vue.$store.state.MENUS.push( {id:-3,nombre:'Facturas',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-6,nombre:'Tesorería',enlace:'-1',icono:'',visualizar:true} )
          }
          else if(cid == 26) {
            vue.$store.state.MENUS.push( {id:-1,nombre:'Mis inscripciones',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-2,nombre:'Postgrados',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-3,nombre:'Facturas',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-4,nombre:'Dashboard',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-5,nombre:'Presupuesto',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-6,nombre:'Tesorería',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-7,nombre: 'Pago',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-8,nombre:'Comision',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-9,nombre:'Planificador',enlace:'-1',icono:'',visualizar:true} )
            // vue.$store.state.MENUS.push( {id:-10,nombre:'Gastos',enlace:'-1',icono:'',visualizar:true} )
          }else if(cid != 24 && cid != 26){
            vue.$store.state.MENUS.push( {id:-1,nombre:'Cargos',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-2,nombre:'Mis inscripciones',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-3,nombre:'Postgrados',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-4,nombre:'Facturas',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-5,nombre:'Dashboard',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-6,nombre:'Planificador',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-7,nombre:'Presupuesto',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-8,nombre:'Tesorería',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-9,nombre: 'Pago',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-10,nombre:'Comision',enlace:'-1',icono:'',visualizar:true} )
            // vue.$store.state.MENUS.push( {id:-11,nombre:'Gastos',enlace:'-1',icono:'',visualizar:true} )
          }else if(sedeid == 34 || sedeid == 35 || sedeid == 36) {
            vue.$store.state.MENUS.push( {id:-1,nombre:'Planificador',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-2,nombre:'Presupuesto',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-3,nombre:'Tesorería',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-4,nombre: 'Pago',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-5,nombre:'Comision',enlace:'-1',icono:'',visualizar:true} )
            // vue.$store.state.MENUS.push( {id:-6,nombre:'Gastos',enlace:'-1',icono:'',visualizar:true} )
          }else{
            vue.$store.state.MENUS.push( {id:-1,nombre:'Postgrados',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-2,nombre:'Planificador',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-3,nombre:'Presupuesto',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-4,nombre:'Tesorería',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-5,nombre: 'Pago',enlace:'-1',icono:'',visualizar:true} )
            vue.$store.state.MENUS.push( {id:-6,nombre:'Comision',enlace:'-1',icono:'',visualizar:true} )
            // vue.$store.state.MENUS.push( {id:-7,nombre:'Gastos',enlace:'-1',icono:'',visualizar:true} )
          }

          const uid = this.$store.state.DATA_USER.id; 
          this.veroferta = (cid == 1 || cid == 2 || cid == 3 || cid == 5 || cid == 13 || cid == 12 || cid == 26 || uid == 35886 || uid==59716 || uid == 11 || uid == 12 || uid == 13) || ((cid == 5 || cid == 6 || cid == 7 || cid == 11 || uid==9029) /* && this.isdevmode */ )

           
        },
        parseCargos(){
          var vue = this;
          this.$store.state.me.cargos.forEach( function(e){
            if( !e.sede ) e.sede = {};
            var ca = e.cargo.nombre;
            var se = e.sede.nombre;
            vue.$store.state.CARGOS.push({ id:e.cargo.id, idsede:e.sede.id, nombre:se+" - "+ca, cargo:e.cargo, sede:e.sede })
          });
          this.$store.state.CARGO = vue.$store.state.CARGOS[0];
          this.setCargosWithSedeStore(this.$store.state.CARGOS);
          this.setCargoSedeStore(this.$store.state.CARGO)
        },
        getGestiones() {
          this.$apollo.query({ query: gql`query{getGestiones{gestion,apertura,cierre}}` })
            .then(({ data: { getGestiones } }) => {
              const data = getGestiones.reverse()
              let anio = new Date().getFullYear();
              let existe = getGestiones.find(x=>x.gestion==anio);
              this.$store.dispatch("gestion/setGestiones", data);
              this.$store.dispatch("gestion/addGestion", {gestion:'todos'});
              this.$store.dispatch("gestion/selectGestion", data.length ? existe :null);
            })
            .catch((error) => {window.console.error(error)});
        },
        getCategorias() {
          let unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
          this.$apollo.query({ query: gql`query { getCategorias(unidad_negocio_id:${unidad_negocio}) {id nombre descripcion estado unidad_negocio_id clase_netsuite_id }}` })
            .then(({ data: { getCategorias } }) => {
              // window.console.log('getCategorias',getCategorias);
              this.$store.dispatch("categoria/setCategorias",getCategorias );
            }).catch(() => []);
        },
        getSedes() {
          const qs = gql` query {getSedes ${''} {id, nombre,unidad_negocio, direccion, telefono1, telefono2, telefono_fijo, latitud, longitud, modelo_recibo, aulas {id},subsidiaria,subsidiaria_id,ubicacion,ubicacion_id, ciudad{ id, nombre, departamento {nombre}}}}`;
          this.$apollo.query({ query: qs })
            .then(({ data: { getSedes } }) => {
              this.$store.dispatch("modsede/setSedes",getSedes.length ? getSedes:[] );
            }).catch(() => []);
        },
        resize(){
          var x = window.screen.width;
          if( x <= 456 ){
            var n = document.getElementById('navbar-primary-na');
            if( !n ) return
            var isColl = n.classList.contains('collapsed');
            if(!isColl) n.classList.add('collapsed');
          }
        },
        /*parseMenusProduccion(){
          let iduser = this.$store.state?.me?.datos_personales?.id;
          let excepcion_permitir_gen_recibos = iduser == 1331; // Carmen julia de camargo es academica y parte contable
          if( excepcion_permitir_gen_recibos ){
            let menucito = {
              enlace: "/recibosesam",
              icono: "glyphicon glyphicon-credit-card",
              id: 360,
              nombre: "Recibos",
              visualizar: true,
            };
            this.$store.state.MENUS.push( menucito );
          }
          let aprobar_descuentos = this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 14 || this.$store.state.CARGO.id == 18;
          let ver_facturas = this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 14 || this.$store.state.CARGO.id == 15 || this.$store.state.CARGO.id == 25 || this.$store.state.CARGO.id == 18;
          // window.console.log( 'aprobar_descuentos',aprobar_descuentos );
          if( aprobar_descuentos ){
            this.$store.state.MENUS.push( {id:-20,nombre:'Descuentos',enlace:'/descuentoslista',icono:'glyphicon glyphicon-inbox',visualizar:true} )
          }
          if( ver_facturas ){
            this.$store.state.MENUS.push( {id:-21,nombre:'Facturas',enlace:'/facturaslista',icono:'glyphicon glyphicon-copy',visualizar:true} )
          }
          // window.console.log( this.$store.state.MENUS,excepcion_permitir_gen_recibos  );
          // window.console.log('this.$store.state::::',this.$store.state)
          
          this.$store.state.MENUS = this.$store.state.MENUS.filter( function(e){
            if( e.nombre == "Mis inscripciones" ) return true;
            else if( e.nombre == "Postgrados" ) return true;
            else if( e.nombre == "Cargos" ) return true;
            else if( e.nombre == "Semaforo" ) return true;
            else if( e.nombre == "Facturas" ) return true;
            else if( e.nombre == "Dashboard" ) return true;
            else if( e.nombre == "Presupuesto" ) return true;
            else if( e.nombre == "Tesorería" ) return true;
            else if( e.nombre == "Pago" ) return true;
            else if( e.nombre == "Comision" ) return true;
            return false;
          })
        },*/
        cargardata() {
            let unidad_negocio = 1;
            if( this.$store.state.CARGO ){
              unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
            }
            // window.console.log('unidad_negocio:::',unidad_negocio)
            if (unidad_negocio == 1) {
              this.$store.state.unidad.mision = process.env.VUE_APP_MISION_ESAM;
              this.$store.state.unidad.vision = process.env.VUE_APP_VISION_ESAM;
              this.$store.state.unidad.about = '';
              this.$store.state.unidad.logo = process.env.VUE_APP_LOGO_ESAM;
              this.$store.state.unidad.postgrados = 'Postgrados';
              this.$store.state.unidad.programas = 'Programas';
            } else if (unidad_negocio == 2 || unidad_negocio == 12) {
              this.$store.state.unidad.mision = process.env.VUE_APP_MISION_CCA;
              this.$store.state.unidad.vision = process.env.VUE_APP_VISION_CCA;
              this.$store.state.unidad.about = '';
              this.$store.state.unidad.logo = process.env.VUE_APP_LOGO_CCA;
              this.$store.state.unidad.postgrados = 'Carreras';
              this.$store.state.unidad.programas = 'Cursos';
            } else if (unidad_negocio == 3) {
              this.$store.state.unidad.mision = process.env.VUE_APP_MISION_CK;
              this.$store.state.unidad.vision = process.env.VUE_APP_VISION_CK;
              this.$store.state.unidad.about = '';
              this.$store.state.unidad.logo = process.env.VUE_APP_LOGO_CK;
              this.$store.state.unidad.postgrados = 'Carreras';
              this.$store.state.unidad.programas = 'Cursos';
            } else if (unidad_negocio == 4) {
              this.$store.state.unidad.mision = process.env.VUE_APP_MISION_CAS;
              this.$store.state.unidad.vision = process.env.VUE_APP_VISION_CAS;
              this.$store.state.unidad.about = '';
              this.$store.state.unidad.logo = process.env.VUE_APP_LOGO_CAS;
              this.$store.state.unidad.postgrados = 'Niveles';
              this.$store.state.unidad.programas = 'Cursos Cas';
            } else {
              this.$store.state.unidad.postgrados = 'Postgrados';
              this.$store.state.unidad.programas = 'Programas';
            }
            //window.console.log(this.$store.state.CARGO.sede);
            // 
          },
        eventomobile(){
          const d = document.getElementById('btn-expand-hi');
          d.addEventListener("click", function(){
            const n = document.getElementById('navbar-primary-na');
            const isColl = n.classList.contains('collapsed');
            if(!isColl) n.classList.add('collapsed');
            else n.classList.remove('collapsed');
          });
        },
  
        async getConveniosUniversidades() {
          const sql = gql`query{ getInstituciones(estado:true){id,nombre,tipo,convenio,abreviatura} }`;
          this.$apollo.query({ query: sql }).then(({ data }) => {
            let conves = data.getInstituciones;
            conves = conves.filter(x=>{return x.convenio});
            this.convenios = conves; 
          });
        }, 
  
        irAWebinars(){
          const unidad = this.$store.state.CARGO.sede.unidad_negocio;
          // window.console.log(unidad);
          if(unidad != 1 && unidad != 10 && unidad != 5 && unidad != 15 ) {
            this.$root.$notify.show(`No disponible para esta unidad de negocio`, {color:'green',x: 'left',});
            return;
          }
          encryptToSendWebinars(this);
        },
        irAWapito(){
          encryptToSendWapito();
        },
        irPortal2(){
          const host = process.env.VUE_APP_PORTAL2_APP;
          const us = getUserData();
          const d = JSON.stringify(us);
          let encodedData = btoa(d); 
          // const host = 'http://localhost:9200'
          const url = host+'?token='+getAccessToken()+'&d='+encodedData; 
          window.open(url);
        }
      },
      mounted(){
        // this.$store.state.DATA_USER = {};
        // this.$store.state.CARGO = {sede:{}};
        let apidev = process.env.VUE_APP_GRAPHQL;
        // window.console.log('apidev:::::><>>',apidev);
        if( apidev.includes("apidev") ){ this.isdevmode = true; }
        else{ this.isdevmode = false; }
        this.cargardata();
  
        // var url = window.location.href;
        // var slack = url.lastIndexOf('/')
        // if( slack > 0 ) url = url.substring( slack )
        // this.$router.push( url )
      }
    }
  </script>
  
